import { render, staticRenderFns } from "./Memoram.vue?vue&type=template&id=15e71f57&"
import script from "./Memoram.vue?vue&type=script&lang=js&"
export * from "./Memoram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports